<script setup>
import { computed, onMounted, ref } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Inertia } from '@inertiajs/inertia';
import { Link, Head, useForm } from '@inertiajs/inertia-vue3';
import BaseIcon from "@/Components/BaseIcon.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import { mdiEye, mdiTrashCan, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiBook, mdiAccessPointCheck,
    mdiPlusCircle, mdiBookOpenVariant, mdiDownload, mdiPaperclip, mdiSend,
    mdiRefresh, mdiInformationOutline, mdiChevronRight, mdiChevronLeft} from "@mdi/js";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeLabel from '@/Components/Label.vue';
import BreezeInput from '@/Components/Input.vue';
import { QuillEditor } from '@vueup/vue-quill'
import BreezeButton from '@/Components/Button.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
// LRR
const props = defineProps({
    titleup: String,
    object: Object,
    guides: Array,
    resources: Array,
    resourceLinks: Array,
    classroom_label: String,
    tasks: Array,
    taskResponses: Array,
    arrayCalifications: Array,
    back_link: String,
    nowDayLetter: String,
    nowDateFormated: String,
    nowDay: String,
    bimestreActual: String,
    semanaActual: Number
});
const data = {
    "estudiante_curso": [
        { "id": 1, "codigo": "2205-ARTE", "name": "ARTE", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
        { "id": 2, "codigo": "2205-BIOLO", "name": "BIOLOGIA", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "última fecha de entrega de trabajos este viernes ..." },
        { "id": 3, "codigo": "2205-FISICA", "name": "FISICA", "tarea": "2/2 (FL 12/10/2022)", "anuncio": "Entrega de trabajo grupal hasta el martes" },
        { "id": 4, "codigo": "2205-QUIMICA", "name": "QUIMICA", "tarea": "4/4 (FL 12/10/2022)", "anuncio": "" },
        { "id": 5, "codigo": "2205-HISTO", "name": "HISTORIA DEL PERU", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
    ]
};

/***
 * LRR
 * los tipos radio sólo se abren una vez, si se cambia a checkbox entonces se puede abrir independiente cada uno y cerrar
 */

let myRadios = document.getElementsByName('tabs2');
let setCheck;
let x = 0;
for (x = 0; x < myRadios.length; x++) {
    myRadios[x].onclick = function () {
        if (setCheck != this) {
            setCheck = this;
        } else {
            this.checked = false;
            setCheck = null;
        }
    };
}

/* const filesForLevel = ref([])
onMounted(() => {
    let url = '/file/listfilesforlevel';
    axios.get(url).then(function (response) {
        var respuesta = response.data;
        filesForLevel.value = respuesta.files;
        //console.log(filesForLevel.value);
    }).catch(function (error) {
        console.log(error);
    });
}); */

const arrayTareaRespuestas = ref([]);

onMounted(() => {
    //console.log(msg)
   // msg1.value = msg
   arrayTareaRespuestas.value = props.taskResponses
});

const listarTareaRespuestas = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/diario';
    axios.get(url).then((resp) => {
        let respuesta = resp.data;
        arrayTareaRespuestas.value = respuesta.diarios;
        console.log(arrayTareaRespuestas.value);
    }).catch(function (error) {
        console.log(error);
    });
}


const isModalActive = ref(false);
const isModalFileActive = ref(false);
const isModalDangerActive = ref(false);
const isModalFullActive = ref(false);
const modalFullSrc = ref('');
const rowID = ref('');
const rowParentID = ref(null);
const rowAction = ref('');
const isErrorForm = ref(false)
const errorMessage = ref('')
const successMessage = ref('')
const titleModal = ref('')

const formTarea = useForm({
    label: '',
    description: '',
    id_file: 0,
    description_collaborator: '',
    status: 0,

});

const initModal = (id, action, data = []) => {
    isErrorForm.value = false
    rowAction.value = action
    titleModal.value = action
    if (action == 'borrador') {
        titleModal.value = 'establecer como borrador'
    } else if (action == 'leer') {
        titleModal.value = 'Respuesta de la'
    } else if (action == 'leertarea') {
        titleModal.value = 'Vista de la'
    }

    if (action == 'registrar') {
    isModalActive.value = true

    } else if (action == 'responder') {
        rowParentID.value = id;// <--
        isModalActive.value = true
        formTarea.label = 'RE: '+data['label']

    } else if (action == 'actualizar') {
        rowID.value = id;
        rowParentID.value = data['id_task'];// Para adjuntar File es registro de la tarearesponse
        isModalActive.value = true
        formTarea.id_file = data['id_file']
        if (data['id_file']) {
            existeAdjunto.value = true
            filePath.value = data['filepath']
            fileName.value = data['filename']
            console.log(filePath.value+' - '+fileName.value)
        }
        formTarea.label = data['label']
        formTarea.description = data['description']
        formTarea.description_collaborator = data['description_collaborator']
        //console.log(rowParentID.value)
    } else if (action == 'leertarea') {
        //rowID.value = id;
        rowParentID.value = id
        isModalActive.value = true
        formTarea.label = data['label']
        formTarea.description = data['description']
        if (data['id_file']) {
            existeAdjunto.value = true
            filePath.value = data['filepath']
            fileName.value = data['filename']
            console.log(filePath.value+' - '+fileName.value)
        }

    } else if (action == 'leer') {
        rowID.value = id;
        isModalActive.value = true
        formTarea.label = data['label']
        formTarea.description = data['description']
        formTarea.id_file = data['id_file']
        if (data['id_file']) {
            existeAdjunto.value = true
            filePath.value = data['filepath']
            fileName.value = data['filename']
            console.log(filePath.value+' - '+fileName.value)
        }
        formTarea.description_collaborator = data['description_collaborator']

    } else {// Casos de publicar o no
        rowID.value = id;
        isModalDangerActive.value = true

    }
}

const isConfirm = () => {
    //alert('Hola '+rowID.value+'modal es '+rowAction.value)
    ///let ruta = props.ruta + '-' + rowAction.value
    let ruta = 'tarearesponse-' + rowAction.value
    
    if (rowAction.value == 'responder') {

        if (!formTarea.label || !formTarea.description) {// || !form.ref 
            isModalActive.value = true
            isErrorForm.value = true
        } else {
            axios.post(route(ruta), {
                'id_task': rowParentID.value,
                'label' : formTarea.label,
                'description' : formTarea.description,
                //'description_collaborator' : formTarea.description_collaborator,
                }).then(function (response) {         
                    console.log('Respuesta creada');
                }).catch(function (error) {
                    console.log(error)
               
            })
            Inertia.reload({ only: ['taskResponses']})
            //console.log('Crear respuesta')
            cleanVal()
            
            //Inertia.reload({ only: ['tasks'], preserveState: true})
           
        }

    } else if (rowAction.value == 'actualizar') {
        
        if (!formTarea.label || !formTarea.description) {
            isModalActive.value = true
            isErrorForm.value = true
        } else {
            axios.put(route(ruta), {
                'id' : rowID.value,
                'label' : formTarea.label,
                'description' : formTarea.description,
                }).then(function (response) {         
                    console.log('Tarea actualizada');
                    cleanVal()
                    Inertia.reload({ only: ['tasks', 'taskResponses'], preserveState: true})
                }).catch(function (error) {
                    console.log(error)
            })
            //refreshList(['tasks', 'taskResponses'])
            //Inertia.reload({ only: ['tasks', 'taskResponses'], preserveState: true})
            //
        }

    } else {
        // Borrado o publicar
        axios.put(route(ruta), {
            'id' : rowID.value,
            }).then(function (response) {         
                console.log('Estado cambiado');
                cleanVal()
                Inertia.reload({ only: ['taskResponses']})
            }).catch(function (error) {
                console.log(error)
        })
    }
    
}

const isCancel = () => {
      cleanVal()
}

const refreshList = (action) => {
    Inertia.reload({ only: action})
    /* if (action == 'tareas') {
        Inertia.reload({ only: ['tasks']})
    } else if (action == 'tareaRespuestas') {
        Inertia.reload({ only: ['taskResponses']})
    } */
}

const tareaEditor = ref(null)// <-- Para limpiar contenido de editor

const cleanVal = (cleanEditor=1) => {
    rowID.value = 0;
    rowParentID.value = null;
    rowAction.value = ''
    modalFullSrc.value = ''
    
    existeAdjunto.value = false
    filePath.value = ''
    fileName.value = ''
    errorMessage.value = ''
    successMessage.value = ''
    //subTextModal.value = 'este registro?'

    // Tarea
    if (cleanEditor) {// <-- No borrar si cierro el editor en nueva edición
        formTarea.id_file = null
        formTarea.label = ''
        formTarea.description = ''
        formTarea.description_collaborator = ''
        formTarea.status = 0
        tareaEditor.value.setContents('')// <-- Limpiar contenido de texto enriquecido
    }
    
    cleanFile(1)
}

const cleanFile = (del_srcid=0) => {
    formFile.id = 
    formFile.file = null
    formFile.filename = ''
    //formFile.src_object_type = 'file_taskresp'
    if (del_srcid) {
        formFile.src_object_id = null
    }
    formFile.name = ''
    formFile.terms = false
    formFile.type = ''

    existeAdjunto.value = false
    isSaveFile.value = false
    filePath.value = ''
    fileName.value = ''
    ShowDeleteFile.value = false
}

// Otra forma de subir archivo
const inputFileName = ref('')
const inputFileDesc = ref('')
const inputFilePos = ref(1)
const showInputFile = ref(false)
//const fileResource = ref(null)// <-- Ref es el ref del input con el mismo nombre
const fileTaskResp = ref(null)
const fileSize = ref (0)
const changeFile = (type) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    let file = null;
    if (type == 'file_resource') {
        //file = fileResource.value.files[0];
    } else if (type == 'file_taskresp') {
        file = fileTaskResp.value.files[0];
    }
    
    //console.log(file);
    console.log(file.size);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (file) {
        fileSize.value = file.size
        if(file.name.includes('.jpg') || file.name.includes('.png')) {
            console.log('Es imagen')
        } else {
            console.log('No es imagen jpg o png')
        }
    } 

}

const uploadFile = (type, origin_id=0) => {
    let data = new FormData()
    let file = null;
    if (type == 'file_resource') {
        //file = fileResource.value.files[0];
        //showAlert('Tipo de origen inválido '+type, 'danger', 5)
        errorMessage.value == response.data.message
    } else if (type == 'file_taskresp') {
        file = fileTaskResp.value.files[0];
    }
    data.append('file', file)
    data.append('origin_type', type)
    if (type == 'file_resource') {
        //showAlert('Tipo de origen inválido '+type, 'danger', 5)
        errorMessage.value == response.data.message
        //data.append('origin_id', props.classroom.id)
        //data.append('origin_id2', props.course.id)
    } else {
        data.append('origin_id', origin_id)
    }
    data.append('name', inputFileName.value)
    data.append('description', inputFileDesc.value)
    data.append('position', inputFilePos.value)
    console.log(file)
    axios.post('/file/upload', data)
    .then(response => {
        
        if (response.data.error) {
            //showAlert(response.data.message, 'danger', 5)
            if (type == 'file_taskresp') {
                errorMessage.value == response.data.message
            }
        } else if (response.data.success) {
            //showAlert(response.data.message, 'success', 2)
            successMessage.value = response.data.message
            cleanInputFile()
            //Inertia.reload({ only: ['resources']})
            if (type == 'file_resource') {
                Inertia.reload({ only: ['resources']})
            } else if (type == 'file_taskresp') {
                isModalActive.value = false
                isConfirm()
                //Inertia.reload({ only: ['tasks']})
            }
            console.log(successMessage.value)
        }
        console.log(response.data)
    })
    .catch(error => {
        console.log(error)
    })

}

const cleanInputFile = () => {
    inputFileName.value = ''
    inputFileDesc.value = ''
    inputFilePos.value = 1
    showInputFile.value = false
    //fileResource.value = null
    //fileTask.value = null
    fileSize.value = 0
}

const ShowDeleteFile = ref(false)
const deleteFile = (id_file, type='file_taskresp') => {
    let ruta = 'file-adjunto-eliminar'
    if (type == 'file_resource') {
        ruta = 'file-eliminar'
    } else if (type == 'file_taskresp') {
        ruta = 'file-eliminar'
    }

    axios.post(route(ruta), {
        'id' : id_file,
        'src_object_type' : type,

    }).then( (response) => { 
        if (response.data.error) {
            //showAlert(response.data.message, 'danger', 5)
            errorMessage.value = response.data.message
        } else if (response.data.success) {
            //showAlert(response.data.message, 'success', 2)
            successMessage.value == response.data.message
            // Esto es para eliminar en resoruces
            //rowID.value = 0
            //rowAction.value = ''
            //Inertia.reload({ only: ['resources']})
            if (type == 'file_resource') {
                // Se elimina desde el botón de lista
                rowID.value = 0
                rowAction.value = ''
                Inertia.reload({ only: ['resources']})
            } else if (type == 'file_taskresp') {
                isModalActive.value = false
                isConfirm()
                //Inertia.reload({ only: ['tasksResponses']})
            }
            console.log(successMessage.value)
        }
        
    }).catch((error) => {
        console.log(error);
    });
    
}

const formatDate = (date) => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result =  (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    return result
}

const formatDateTime = (datetime) => {
    var date = new Date(datetime)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result =  (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + '-' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
    return result
}

// Subir archivo
const formFile = useForm({
    id: 0,
    file: null,
    filename: '',
    //oldfilepath: '',
    //oldfilename: '',
    //originName: '',
    src_object_type: 'file_taskresp',
    src_object_id: rowParentID.value??null,
    name: '',
    terms: false,
    type: ''
});

const filePath = ref('')
const fileName = ref('')
const existeAdjunto = ref(false)
const isSaveFile = ref(false)
const isImagen = ref(false)
const imgMiniatura = ref('')
const handleFileUp = (event) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    //fileSubida.value = event.target.files[0];
    //console.log(event.target.files[0]);

    

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (event.target.files && event.target.files.length) {
        formFile.originName = event.target.files[0].name
        if(formFile.originName.includes('.jpg') || formFile.originName.includes('.png')) {
            isImagen.value = true
        } else {
            isImagen.value = false
        }

        let file = event.target.files[0];
        //this.product.imagen=file
        formFile.file = file
        //console.log(file)
        console.log(formFile.file)
        fileUp(file)
    } 

}

const fileUp = (file) => {
    let reader = new FileReader()
    reader.onload = (e) => {
        imgMiniatura.value = e.target.result
    }
    reader.readAsDataURL(file)
}

const submit = (action) => {

    /* form.post(route('file-registrar'), {
        //onFinish: () => form.reset('password', 'password_confirmation'),
    }); */

    // debug
    //console.log(rowID.value + ' ID-label ' + formTarea.label)
    //console.log(formFile.src_object_id + ' IDSRC-Name ' + formFile.name)

    if (action=='create') {
        formFile.post(route('file-adjunto-registrar'), {
            //onSuccess: () => form.reset('apellidos', 'nombres', 'email', 'telefono', 'celular', 'obs_aprendizaje'),
            onFinish: () => {
                console.log('Attach Success')
                isConfirm()
                isModalActive.value = false
            }
        });

    } /* else {
        formFile.put(route('file-adjunto-eliminar'), {
            //onFinish: () => form.reset('apellidos, nombres, email, telefono, celular, obs_aprendizaje'),
        });
    } */

    //cleanVal()
    //Inertia.reload({ only: ['tasks', 'taskResponses']})
};

const backLink = ref('/#'+props.back_link)

</script>

<template>

    <Head :title="object.label" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                AULA: {{ classroom_label }} - CURSO: {{ object.label }} 
            </h2>
        </template>
        <!-- Vista previa -->
        <CardBoxModal v-model="isModalFullActive" title="Vista previa" sizeModal="full" hasCancel><!-- tien el botón de cancelar superior-->
            <div class="flex justify-center w-full">
                <embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full"><!-- w-full es para documetnos w-auto para imágenes-->
            </div>
        </CardBoxModal>
        <!-- Tareas -->
        <CardBoxModal v-model="isModalActive" hasCancel :title="(titleModal + ' tarea')" @confirm="isConfirm" @cancel="isCancel" sizeModal="medium" :noButtons="(rowAction == 'leer' || rowAction == 'leertarea' ? true : false)">

            <div v-if="isErrorForm" class="mb-4">
                <div class="font-medium text-red-600">Ups! Debe registrar los campos requeridos</div>
            </div>
            
            <div>
                <BreezeLabel for="title" value="Título"/>
                <BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="formTarea.label" :disabled="(rowAction == 'leer' || rowAction == 'leertarea' ? true : false)" required autocomplete="label" />
            </div>
            <div>
                <!-- <span>Descripción (Html) <span class="text-red-600" > * </span></span><span @click="showHtmlText=!showHtmlText">Vista previa<BaseIcon :path="mdiEye" :size="18" class="mr-3 " /></span>
                <
                <div v-else class="p-2" v-html="form.description"></div> -->
                <BreezeLabel for="description" value="Descripción" />
                <!-- PRopiedades: readOnly, toolbar="" -> Sin toolbar, :toolbar="['']" -> Agregar toolbarr personalizado sólo resaltado y sub indice -->
                <QuillEditor v-if="rowAction == 'leer' || rowAction == 'leertarea'" ref="tareaEditor" style="min-height:200px;" v-model:content="formTarea.description" contentType="html" :toolbar="[]" theme="snow" readOnly/>
                <QuillEditor v-else ref="tareaEditor" style="min-height:200px;" v-model:content="formTarea.description" contentType="html" toolbar="essential" theme="snow" placeholder="Debe ingresar un contenido, al menos un punto" />
                <div v-if="rowAction == 'leer'">
                    <BreezeLabel for="comment" value="Comentario del docente" />
                    <QuillEditor ref="tareaEditor" style="min-height:100px;" v-model:content="formTarea.description_collaborator" contentType="html" :toolbar="[]" theme="snow" readOnly/>
                </div>
            </div>
            <div v-if="rowAction == 'responder'" class="text-blue-600"> Podrá adjuntar un archivo luego de crear la respuesta de esta tarea (al editar) </div>
            <div v-if="rowAction == 'actualizar'">
                <template v-if="!existeAdjunto">
                    <!-- <BreezeValidationErrors class="mb-4" />
                    <form @submit.prevent="submit('create')" enctype="multipart/form-data">
                        <div class="mt-4" :set="formFile.src_object_id=rowID">
                            <BreezeLabel for="file" value="Subir archivo (opcional)"/>
                            <BreezeInput id="file" ref="file" type="file" class="mt-1 block w-full" autocomplete="file" @change="handleFileUp" accept=".PDF, .PNG, .JPG" />
                        </div>
                        <div v-if="isSaveFile" class="mb-2" >
                            <div class="font-medium text-green-600">Cargando Adjunto</div>
                        </div>
                        
                        <BreezeButton class="mt-2" :class="{ 'opacity-25': formFile.processing }" :disabled="formFile.processing" :set="formFile.name='RESP'+rowID+'_TAREA'+rowParentID">
                            Guardar Adjunto
                        </BreezeButton>
                    </form> -->

                    <BreezeLabel for="file" value="Subir archivo (opcional)" class="mb-4"/>
                    <div v-if="errorMessage" class="mb-4">
                        <div class="font-medium text-red-600">{{ errorMessage }}</div>                          
                    </div>
                    <div v-if="fileSize > (1000 * parseInt(confGlobal.value.TASKRESP_LIMIT_UPLOAD_FILE))" class="mb-4">
                        <div class="font-medium text-red-600">El archivo supera el tamaño límite permitido de {{ confGlobal.value.TASKRESP_LIMIT_UPLOAD_FILE }} KB</div>
                    </div>
                    <div class="mt-4">
                        
                        <!-- <BreezeInput id="file" ref="file" type="file" class="mt-1 block w-full" v-model="formFile.originName" autocomplete="file" @change="handleFileUp" accept=".PDF, .PNG, .JPG" /> --><!--.XLSX, -->
                        <input id="file_taskresp" ref="fileTaskResp" type="file" class="mt-1 block" @change="changeFile('file_taskresp')" accept=".PDF, .PNG, .JPG, .DOC, .DOCX" >
                    </div>
                    
                    <BreezeButton class="mt-2" @click="uploadFile('file_taskresp', rowID)" :set="inputFileName='RESP'+rowID+'_TAREA'+rowParentID">
                        Guardar Adjunto
                    </BreezeButton>
                </template>
                <template v-else>
                    <div v-if="filePath && fileName">
                        <div class="text-blue-600"> La vista previa es compatible con imagen y PDF (para otros archivos consulte la ayuda 1.1) </div>
                        <div class="inline-block"> 
                            <embed :src="'/documents/'+filePath+'/'+fileName" class="object-cover h-48">
                        </div>
                        <div class="inline-block mt-2 ml-4">
                            <BaseButton
                                color="info"
                                :icon="mdiDownload"
                                small
                                title="Descargar"
                                label="Descargar"
                                :href="route('file-download', {'srctype': 'file_taskresp', 'srcid': rowID, 'filename': fileName })"
                                target="_blank"
                            />
                        </div>
                        <div class="inline-block mt-2 ml-6">
                            <span @click="ShowDeleteFile=!ShowDeleteFile" class="font-medium text-red-600">[ x Eliminar archivo] </span>
                            <span v-if="ShowDeleteFile" > Seguro? <span>
                                <BaseButton color="danger" :icon="mdiTrashCan" small @click="deleteFile(formTarea.id_file)" class="ml-2" />
                            </span></span>
                        </div>
                    </div>
                    <div v-else>
                        Error en archivo adjunto
                    </div>
                </template>
                
            </div>
            <div v-else-if="rowAction=='leer' || rowAction=='leertarea'">
                <div v-if="existeAdjunto && filePath && fileName">
                    <div class="inline-block"> 
                        <embed :src="'/documents/'+filePath+'/'+fileName" class="object-cover h-48">
                    </div>
                    <div class="inline-block mt-2 ml-4">
                        <BaseButton
                            color="info"
                            :icon="mdiDownload"
                            small
                            title="Descargar"
                            label="Descargar"
                            :href="route('file-download', {'srctype': ( rowAction=='leertarea' ? 'file_task' : 'file_taskresp'), 'srcid': (rowAction=='leertarea' ? rowParentID : rowID), 'filename': fileName })"
                            target="_blank"
                        />
                    </div>
                    
                </div>
                <div v-else class="text-blue-600">
                    Sin adjunto
                </div>
            </div>

        </CardBoxModal>
        <CardBoxModal
            v-model="isModalDangerActive"
            title="Por Confirmar"
            button="danger"
            hasCancel
            @confirm="isConfirm"
            @cancel="isCancel"
        >
            <p>Está seguro de <b>{{ titleModal }}</b></p>
            <p><b>¡Una vez publicada ya no podrá modificarla!</b></p>
        </CardBoxModal>
        <!-- <CardBoxModal v-model="isModalFileActive">
            
        </CardBoxModal> -->
        <section>
            <div class="pb-12">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-4">
                    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
                        
                        <div
                            class="col-span-1 sm:col-span-2 xl:col-span-3 bg-white rounded-lg shadow-lg py-10 px-6 bg-no-repeat md:bg-[url('/img/course/card/arte.png')] bg-contain bg-right h-full">
                            <div class="flex items-center h-full">
                                <div class="grid grid-cols-4 gap-6">
                                    <div class="col-span-4">
                                        <h5 class="text-gray-900 text-xl font-bold">Contenido del Curso</h5>
                                        <p>
                                            Estrategias y herramientas para la supervisión y seguimiento de tu curso.
                                        </p>
                                    </div>
                                    <div class="col-span-4 md:col-span-2">
                                        <div
                                            class="flex items-star justify-between rounded-md mb-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                            <div class="flex gap-3">
                                                <div>
                                                    <div
                                                        class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-lime-400 focus:shadow-outline hover:bg-lime-600">
                                                        <BaseIcon :path="mdiBookOpenVariant" :size="24" />
                                                    </div>
                                                </div>

                                                <div>
                                                    <!-- <h5 class="font-semibold text-md">Próximo Examen</h5>
                                                    <p class="text-sm">18 de Abril del 2023</p> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-span-4 md:col-span-2">
                                        <div
                                            class="flex items-star justify-between rounded-md mb-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                            <div class="flex gap-3">
                                                <div>
                                                    <div
                                                        class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-fuchsia-500 focus:shadow-outline hover:bg-fuchsia-700">
                                                        <BaseIcon :path="mdiBookOpenVariant" :size="24" />
                                                    </div>
                                                </div>

                                                <div>
                                                    <!-- <h3 class="font-semibold text-md">Cierre del Bimestre</h3>
                                                    <p class="text-sm">30 de Abril del 2023</p> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-span-1 min-h-[220px]">
                            <div class="my-auto h-full bg-white rounded-lg shadow-lg p-5 w-full min-h-[220px]">
                                <div class="flex justify-between items-center mb-4">
                                    <button type="button"
                                        class="p-1 py-1 text-center text-black bg-white-500 rounded-lg hover:bg-white-700 focus:ring-4 focus:outline-none focus:ring-white-300 h-9 w-9 flex items-center justify-center">
                                        <BaseIcon :path="mdiChevronLeft" :size="20" />
                                    </button>
                                    <h1 class="text-gray-900 text-lg font-bold">{{ nowDateFormated }}</h1>
                                    <button type="button"
                                        class="p-1 py-1 text-center text-black bg-white-500 rounded-lg hover:bg-white-700 focus:ring-4 focus:outline-none focus:ring-white-300 h-9 w-9 flex items-center justify-center">
                                        <BaseIcon :path="mdiChevronRight" :size="20" />
                                    </button>
                                </div>
                                <div
                                    class="inline-flex items-center capitalize leading-none text-xs border rounded py-1 px-3 bg-gray-200 text-black mb-2">
                                    <span> Temario</span>
                                </div>
                                <p> No existe un tema registrado para hoy.
                                </p>
                            </div>
                        </div>

                        <div class="col-span-1 h-full">
                            <div class="h-full">
                                <div
                                    class="my-auto bg-orange-500 rounded-lg shadow-lg p-4 text-center flex items-center justify-center h-[calc(100%-56px)] min-h-[170px]">
                                    <div>
                                        <span class="text-white font-bold">{{ nowDayLetter }}</span>
                                        <br>
                                        <span class="text-[30px] lg:text-[60px] text-white font-bold">{{ nowDay }}</span>
                                        <br>
                                        <span class="text-white font-bold">Semana {{ semanaActual }}</span>
                                        <br>
                                        <span class="text-white font-bold">{{ bimestreActual }}</span>
                                    </div>

                                </div>

                                <div class=" bg-white rounded-lg shadow-lg h-[40px] mt-4">
                                    <Link :href="route('student-courses')+backLink" class="btn btn-blue w-full h-full flex items-center justify-center">Volver al listado de cursos</Link>
                                </div> 
                            </div>



                        </div>



                        <!-- Versión 1.0 Promedio de Notas
                    <div
                        class="md:col-span-1 my-auto bg-rose-600 rounded-lg shadow-lg p-6 h-full text-center flex justify-center items-center">
                        <div><span class="text-white font-bold">Promedio</span><br><span
                                class="text-[30px] lg:text-[60px] text-white font-bold">17</span><br><span
                                class="text-white font-bold">Por Bimestre</span><br></div>
                    </div>
                    -->
                    </div>
                </div>
                <!-- Secciones del curso -->
                <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                    <div class="grid grid-cols-4 gap-4">
                        <div class="col-span-4 md:col-span-3 bg-white overflow-hidden shadow-lg rounded-lg p-6">
                            <div
                                class="bg-white tab tab-rose w-full overflow-hidden border border-red-200  mb-6 rounded-lg">
                                <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-single-one"
                                    type="radio" name="tabs2">
                                <label class="block p-5 leading-normal cursor-pointer bg-red-100 content-center"
                                    for="tab-single-one" style="height: 66px">
                                    <div class="my-auto inline-flex items-center" style="height: 24px">
                                        <span class="inline-flex font-semibold text-red-600">
                                            <BaseIcon :path="mdiBookOpenVariant" :size="24" class="mr-3 " />
                                            Decripción del curso
                                        </span>
                                    </div>

                                </label>
                                <div
                                    class="tab-content overflow-hidden border-l-2 border-rose-600  bg-white leading-normal">
                                    <p class="p-5">
                                        {{ object.description ?? 'Sin descripción' }}
                                    </p>
                                </div>
                            </div>


                            <!-- Tareas -->
                            <div
                                class="bg-white tab tab-blue w-full overflow-hidden border border-blue-200 mb-6 rounded-lg">
                                <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-single-two"
                                    type="radio" name="tabs2">
                                <label class="block p-5 leading-normal cursor-pointer bg-blue-100 content-center"
                                    for="tab-single-two" style="height: 66px">
                                    <div class="my-auto inline-flex items-center" style="height: 24px">
                                        <span class="inline-flex font-semibold text-blue-600">
                                            <BaseIcon :path="mdiBookOpenVariant" :size="24" class="mr-3 " />
                                            Tareas
                                        </span>
                                    </div>

                                </label>
                                <div
                                    class="tab-content overflow-hidden border-l-2 border-blue-600  bg-white leading-normal">
                                    <div class="w-full flex justify-start mt-4 ml-4">
                                        <!-- <BaseButton :icon="mdiPlusCircle" color="info"
                                            icon-size="20" small label="Nueva tarea" @click="initModal('', 'registrar')"/> -->
                                        <BaseButton :icon="mdiRefresh" color="info" class="ml-4"
                                            icon-size="20" small label="Refresh" @click="refreshList(['tasks', 'taskResponses'])"/>
                                    </div>
                                    <div class="p-4">
                                        <div>
                                            <BaseIcon
                                                :path="mdiInformationOutline"
                                                size="15"
                                            /> Si el maestro publica la tarea en este momento click en Refresh para actualizar.
                                            Una vez publicada las respuestas de las tareas ya no podrá editarla, a menos que el maestro lo vuelva a borrador luego podrá hacer los cambios para volverlo a enviar.
                                        </div>
                                        <div v-if="tasks.length">
                                            <lu>
                                                <li>Debe crear una respuesta a la tarea para iniciar el proceso. Si luego de crear no se muestra, click en el botón Refrescar.</li>
                                                <li>Al editar una respuesta podrá adjuntar un archivo si fuera necesario. Puede adjuntar cualquier tipo de archivo pero la vista previa sólo está disponible en imagen y PDF.</li>
                                            </lu>
                                        </div>
                                        
                                    </div>
                                    <table v-if="tasks.length" class="table-auto">
                                        <thead>
                                            <tr>
                                                <th>Título</th>
                                                <th>Finaliza el</th>
                                                <th>Último envío</th>
                                                <th>Nota</th>
                                                <th>Estado</th>
                                                <th> </th>
                                            </tr>
                                        </thead>
                                        <tbody class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]" :set="taskResp=[]">
                                            <tr  v-for="(task, index) in tasks" :key="task.id" :set="taskResp[index] = taskResponses.find(item => item.id_task == task.id)">
                                                <td data-label="Nombre" class="bg-gray-100 lg:bg-transparent"> {{ task.label }} </td>
                                                <td data-label="Finaliza el"> {{ formatDateTime(task.end_date) }}</td><!-- task.end_date.format('DD/MM/YYYY')  new Date().toLocaleDateString() -->
                                                <td data-label="Publicado el" :class="(taskResp[index] && taskResp[index].end_date > task.end_date ? 'text-red-600' : '')"> {{ taskResp[index] && taskResp[index].status  ? formatDateTime(taskResp[index].end_date) : ''}}</td>
                                                <td data-label="Nota" :class="(taskResp[index] && taskResp[index].calification < 11 ? 'text-red-600' : '')"> {{ taskResp[index] ? parseInt(taskResp[index].calification) : '-'}}</td>
                                                <td data-label="Estado"> 
                                                    <div v-if="taskResp[index] && !taskResp[index].status" class="ml-2 bg-white text-gray-600 px-3 py-2 text-xs font-medium text-center border border-gray-200 rounded ">
                                                        Borrador
                                                        <BaseIcon v-if="taskResp[index].id_file" :path="mdiPaperclip" :size="14" :incSpan="false"/>
                                                    </div>

                                                    <div v-else class="ml-2 bg-green-100 text-green-600 px-3 py-2 text-xs font-medium text-center border border-green-200 rounded ">
                                                        Publicado
                                                        <BaseIcon v-if="taskResp[index] && taskResp[index].id_file" :path="mdiPaperclip" :size="14" :incSpan="false"/>
                                                    </div>

                                                    <!-- <div
                                                        class="bg-red-100 text-red-600 px-3 py-2 text-xs font-medium text-center border border-red-200 rounded ">
                                                        Anulado
                                                    </div> -->
                                                    <!-- <div v-if="taskResp[index].id_file" class="ml-2 bg-blue-100 text-blue-600 px-3 py-2 text-xs font-medium text-center border border-blue-200 rounded ">
                                                        <BaseIcon :path="mdiPaperclip" :size="14" :incSpan="false"/>
                                                    </div> -->
                                                </td>
                                                <td class="flex justify-center">
                                                    <!-- {{ task }} -->
                                                    <BaseButtons type="justify-start lg:justify-end">
                                                        <!-- class="hidden lg:grid" quitar para ver tarea sin adjunto -->
                                                        <BaseButton
                                                            color="info"
                                                            :icon="mdiEye"
                                                            small
                                                            title="Ver tarea"
                                                            label="T"
                                                            @click="initModal(task.id, 'leertarea', task)"
                                                            
                                                        />
                                                        <!-- <span class="">{{ taskResp = taskResponses.find(item => item.id_task == task.id) }}</span> -->
                                                        
                                                        <!-- <BaseButton
                                                            color="info"
                                                            :icon="mdiEye"
                                                            
                                                            @click="(isModalFullActive = true, modalFullSrc = '/documents/'+guide.filepath+'/'+guide.filename)"
                                                            class="hidden lg:grid"
                                                        /> -->
                                                        <BaseButton
                                                            v-if="!taskResp[index]"
                                                            color="info"
                                                            :icon="mdiPlusCircle"
                                                            small
                                                            title="Responder"
                                                            label="Responder"
                                                            @click="initModal(task.id, 'responder', task)"
                                                            />
                                                        <BaseButton
                                                            v-if="!taskResp[index]"
                                                            color="info"
                                                            :icon="mdiRefresh"
                                                            small
                                                            title="Refrescar"
                                                            
                                                            @click="refreshList(['taskResponses'])"
                                                        />
                                                        <template v-if="taskResp[index]">
                                                            <!-- {{ taskResp[index].id }} -->
                                                            <BaseButton
                                                            v-if="taskResp[index].status"
                                                            color="info"
                                                            :icon="mdiEye"
                                                            small
                                                            title="Ver respuesta"
                                                            label="R"
                                                            @click="initModal(taskResp[index].id, 'leer', taskResp[index])" 
                                                            />
                                                            <BaseButton
                                                            v-else
                                                            color="warning"
                                                            :icon="mdiPencil"
                                                            small
                                                            title="Editar Respuesta"
                                                            label="R"
                                                            @click="initModal(taskResp[index].id, 'actualizar', taskResp[index])"
                                                            />
                                                           <!-- quitar  class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white hover:bg-red-700 hover:border-red-700 hover:dark:bg-red-600 hover:dark:border-red-600 p-1 mr-3 last:mr-0 mb-3" -->
                                                            
                                                           <!-- <BaseButton
                                                            v-if="taskResp[index].status"
                                                            color="success"
                                                            :icon="mdiCheckCircle"
                                                            small
                                                            title="Publicado"
                                                            /> -->
                                                            <BaseButton
                                                                v-if="!taskResp[index].status"
                                                                color="contrast"
                                                                :icon="mdiSend"
                                                                small
                                                                @click="initModal(taskResp[index].id, 'publicar')"
                                                                title="Enviar Respuesta"
                                                            />
                                                        </template>
                                                        
                                                    </BaseButtons>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-else class="p-5">
                                        Aun no hay tareas registradas en este curso

                                    </p>
                                   
                                </div>
                            </div>

                            <!-- Recursos y guias -->
                            <div
                                class="bg-white tab tab-yellow w-full overflow-hidden border border-yellow-200 rounded-lg mb-6">
                                <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-single-four"
                                    type="radio" name="tabs2">
                                <label class="block p-5 leading-normal cursor-pointer bg-yellow-100 content-center"
                                    for="tab-single-four" style="height: 66px">
                                    <div class="my-auto inline-flex items-center" style="height: 24px">
                                        <span class="inline-flex font-semibold text-yellow-600">
                                            <BaseIcon :path="mdiBookOpenVariant" :size="24" class="mr-3 " />
                                            Recursos de estudio
                                        </span>
                                    </div>

                                </label>
                                <div class="tab-content overflow-hidden border-l-2 border-yellow-600  bg-white leading-normal">
                                    <div class="w-full flex justify-start mt-4 ml-4">
                                        <BaseButton :icon="mdiRefresh" color="info" class="ml-4"
                                            icon-size="20" small label="Refresh" @click="refreshList(['resources', 'resourceLinks'])"/>
                                    </div>
                                    <table v-if="resources.length" class="table-auto mb-4">
                                        <thead>
                                            <tr>
                                                <th>Recursos Adjunto</th>
                                                <th>Descripción</th>
                                                <th>Tipo</th>
                                                <th> </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr  v-for="resource in resources" :key="resource.id" >
                                                <td data-label="Recurso Adjunto"> {{ resource.name }} </td>
                                                <td data-label="Descripción"> {{ resource.description }}</td>
                                                <td data-label="Tipo"> {{ resource.extension }}</td>
                                                <td class="flex justify-center">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                        <!-- <BaseButton :icon="mdiEye" color="info" icon-size="w-20 h-20" class="mr-4 lg:inline-flex hidden"/> -->
                                                        <!-- <BaseButton :icon="mdiDownload" color="info" icon-size="w-20 h-20"/> -->
                                                        <BaseButton
                                                            color="info"
                                                            :icon="mdiEye"
                                                            
                                                            @click="(isModalFullActive = true, modalFullSrc = '/documents/'+resource.filepath+'/'+resource.filename)"
                                                            class="hidden lg:grid"
                                                        />
                                                        <BaseButton
                                                            color="info"
                                                            :icon="mdiDownload"
                                                            small
                                                            :href="route('file-download2', {'srctype': 'file_resource', 'srcid': resource.src_object_id, 'filename': resource.filename, 'srcid2': resource.origin_id2 })"
                                                            target="_blank"
                                                        />
                                                    </BaseButtons>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <!-- Links -->
                                    <table v-if="resourceLinks.length" class="table-auto mb-4">
                                        <thead>
                                            <tr>
                                                <th>Recursos Link</th>
                                                <th>Descripción</th>
                                                <th>Link</th>
                                                <th> </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr  v-for="resourceLink in resourceLinks" :key="resourceLink.id" >
                                                <td data-label="Recurso Link"> {{ resourceLink.label }} </td>
                                                <td data-label="Descripción"> {{ resourceLink.description }} </td>
                                                <td data-label="Tipo"> <a class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" :href="resourceLink.url" title="Click para abrir link" target="_blank">Link</a></td>
                                                <td class="flex justify-center">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                    </BaseButtons>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table v-if="guides.length" class="table-auto">
                                        <thead>
                                            <tr>
                                                <th>Guías de estudio</th>
                                                <th>Descripción</th>
                                                <th> </th>
                                                <th> </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr  v-for="guide in guides" :key="guide.id" >
                                                <td data-label="Guía de estudio"> {{ guide.name }} </td>
                                                <td data-label="Descripción"> {{ guide.description }}</td>
                                                <td></td>
                                                <td class="flex justify-center">
                                                    <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                                        <!-- <BaseButton :icon="mdiEye" color="info" icon-size="w-20 h-20" class="mr-4 lg:inline-flex hidden"/> -->
                                                        <!-- <BaseButton :icon="mdiDownload" color="info" icon-size="w-20 h-20"/> -->
                                                        <BaseButton
                                                            color="info"
                                                            :icon="mdiEye"
                                                            
                                                            @click="(isModalFullActive = true, modalFullSrc = '/documents/'+guide.filepath+'/'+guide.filename)"
                                                            class="hidden lg:grid"
                                                        />
                                                        <BaseButton
                                                            color="info"
                                                            :icon="mdiDownload"
                                                            small
                                                            :href="route('file-download', {'srctype': 'file_guideforcourse', 'srcid': (guide.src_object_id ? guide.src_object_id : 0), 'filename': guide.filename })"
                                                            target="_blank"
                                                        />
                                                    </BaseButtons>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-else class="p-5">
                                        Sin guías de estudio para este curso
                                    </p>
                                </div>
                            </div>

                            <!-- Calificaciones -->
                            <div
                                class="bg-white tab tab-green w-full overflow-hidden border border-green-200 rounded-lg mb-6">
                                <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-single-three"
                                    type="radio" name="tabs2">
                                <label class="block p-5 leading-normal cursor-pointer bg-green-100 content-center"
                                    for="tab-single-three" style="height: 66px">
                                    <div class="my-auto inline-flex items-center" style="height: 24px">
                                        <span class="inline-flex font-semibold text-green-600">
                                            <BaseIcon :path="mdiBookOpenVariant" :size="24" class="mr-3 " />
                                            Mis Calificaciones
                                        </span>
                                    </div>

                                </label>
                                <div class="tab-content overflow-hidden border-l-2 border-green-600  bg-white leading-normal">
                                    <div v-if="arrayCalifications.length">
                                        <table class="table-auto">
                                            <thead>
                                                <tr>
                                                    <th class="text-center" title="Bimestre">Bimestre</th>
                                                    <th class="text-center" title="Asistencia">Asist.</th>
                                                    <th class="text-center" title="Participación">Part.</th>
                                                    <th class="text-center" title="Tarea">Tarea</th>
                                                    <th class="text-center" title="Conducta">Conducta</th>
                                                    <th class="text-center" title="Examen parcial">Ex. parcial</th>
                                                    <th class="text-center" title="Examen parcial2">Ex. parcial2</th>
                                                    <th class="text-center" title="Examen final">Ex. final</th>
                                                    <th class="text-center" title="Promedio">Promedio</th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody class="overflow-y-auto lg:contents block lg:max-h-max max-h-[600px]">
                                                <tr v-for="cal, in arrayCalifications" :key="cal.id">
                                                    <td data-label="Bimestre" class="bg-gray-100 lg:bg-transparent">
                                                        <span>{{ cal.label  }}</span>
                                                    </td>
                                                    <td class="text-center" data-label="Asistencia">
                                                        <!-- {{ formatNotaOut(cal.asistencia) }} -->
                                                        <span>{{ cal.asistencia  }}</span>
                                                        
                                                    </td>
                                                    <td class="text-center" data-label="Participación">
                                                        <!-- {{ formatNotaOut(cal.participacion) }} -->
                                                        <span>{{ cal.participacion  }}</span>
                                                        
                                                    </td>
                                                    <td class="text-center" data-label="Tarea">
                                                        <!-- {{ formatNotaOut(cal.tarea) }} -->
                                                        <span>{{ cal.tarea  }}</span>
                                                        
                                                    </td>
                                                    <td class="text-center" data-label="Conducta">
                                                        <!-- {{ formatNotaOut(cal.conducta) }} -->
                                                        <span>{{ cal.conducta  }}</span>
                                                        
                                                    </td>
                                                    <td class="text-center" data-label="Examen parcial" >
                                                        <!-- {{ formatNotaOut(cal.examen_parcial) }} -->
                                                        <span>{{ cal.examen_parcial  }}</span>
                                                       
                                                    </td>
                                                    <td class="text-center" data-label="Examen parcial2">
                                                        <!-- {{ formatNotaOut(cal.examen_parcial2) }} -->
                                                        <span>{{ cal.examen_parcial2 }}</span>
                                                        
                                                    </td>
                                                    <td class="text-center" data-label="Examen final">
                                                        <!-- {{ formatNotaOut(cal.examen_final) }} -->
                                                        <span>{{ cal.examen_final  }}</span>
                                                        
                                                    </td>
                                                    <td class="text-center" :class="(cal.promedio < 11  ? 'text-red-600' : '')">
                                                        <!-- {{ formatNotaOut(cal.promedio) }} -->
                                                        <span>{{ cal.promedio  }}</span>
                                                        
                                                    </td>
                                                    
                                                </tr>

            

                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-else class="p-5">
                                        Aun no tenemos notas registradas para este curso
                                    </div>
                                </div>
                            </div>


                            <!-- <div
                                class="bg-white tab tab-purple w-full overflow-hidden border border-purple-200 rounded-lg mb-6">
                                <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-single-three"
                                    type="radio" name="tabs2">
                                <label class="block p-5 leading-normal cursor-pointer bg-purple-100 content-center"
                                    for="tab-single-three" style="height: 66px">
                                    <div class="my-auto inline-flex items-center" style="height: 24px">
                                        <span class="inline-flex font-semibold text-purple-600">
                                            <BaseIcon :path="mdiBookOpenVariant" :size="24" class="mr-3 " />
                                            Mis Calificaciones
                                        </span>
                                    </div>

                                </label>
                                <div
                                    class="tab-content overflow-hidden border-l-2 border-green-600  bg-white leading-normal">
                                    <p class="p-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                        Tenetur,
                                        architecto, explicabo perferendis nostrum, maxime impedit atque odit sunt
                                        pariatur
                                        illo
                                        obcaecati soluta molestias iure facere dolorum adipisci eum? Saepe, itaque.
                                    </p>
                                </div>
                            </div> -->

                            <!-- <div
                                class="bg-white tab tab-gray w-full overflow-hidden border border-gray-200 rounded-lg mb-6">
                                <input class="absolute opacity-0 bg-indigo text-grey-lightest" id="tab-single-three"
                                    type="radio" name="tabs2">
                                <label class="block p-5 leading-normal cursor-pointer bg-gray-100 content-center"
                                    for="tab-single-three" style="height: 66px">
                                    <div class="my-auto inline-flex items-center" style="height: 24px">
                                        <span class="inline-flex font-semibold text-gray-600">
                                            <BaseIcon :path="mdiBookOpenVariant" :size="24" class="mr-3 " />
                                            Mis Calificaciones
                                        </span>
                                    </div>

                                </label>
                                <div
                                    class="tab-content overflow-hidden border-l-2 border-green-600  bg-white leading-normal">
                                    <p class="p-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                                        Tenetur,
                                        architecto, explicabo perferendis nostrum, maxime impedit atque odit sunt
                                        pariatur
                                        illo
                                        obcaecati soluta molestias iure facere dolorum adipisci eum? Saepe, itaque.
                                    </p>
                                </div>
                            </div> -->
                        </div>

                        <div class="col-span-4 md:col-span-1 h-full shadow-lg rounded-lg">
                            <img class="w-full object-cover rounded-lg h-full" src="/img/course/card/bg.jpg">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </BreezeAuthenticatedLayout>
</template>